import {
  DELETE_EXPENDITURE_RULE,
  DELETE_EXPENDITURE_RULE_SUCCESS,
  DELETE_EXPENDITURE_RULE_ERROR,
  DELETE_EXPENDITURE_RULE_EMPTY,
} from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DeleteExpenditureRule = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_EXPENDITURE_RULE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DELETE_EXPENDITURE_RULE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DELETE_EXPENDITURE_RULE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DELETE_EXPENDITURE_RULE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DeleteExpenditureRule;
